<template>
  <div>
    <a href="https://duda.co" target="_blank">
      <img
        :style="logoStyle"
        alt="duda"
        src="https://duda-signature.dud4.co/duda.png"
      />
    </a>
    <a href="https://www.linkedin.com/company/duda/" target="_blank">
      <img
        :style="iconStyle"
        alt="linkedin"
        src="https://duda-signature.dud4.co/linkedin.png"
    /></a>
    <a href="https://twitter.com/Duda_Inc" target="_blank">
      <img
        :style="iconStyle"
        alt="twitter"
        src="https://duda-signature.dud4.co/twitter.png"
    /></a>
    <a href="https://www.instagram.com/dudalife_/" target="_blank">
      <img
        :style="iconStyle"
        alt="instagram"
        src="https://duda-signature.dud4.co/instagram.png"
    /></a>
    <a href="https://www.facebook.com/duda/" target="_blank">
      <img
        :style="iconStyle"
        alt="facebook"
        src="https://duda-signature.dud4.co/facebook.png"
    /></a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoStyle: {
        width: "60px",
        "margin-top": "10px",
      },
      iconStyle: {
        width: "25px",
        margin: "0 0 2px 15px",
      },
    };
  },
};
</script>
